import { defineMessages } from 'react-intl';

const scope = 'app.components.TapToTip.Setup.LandingMessageSection';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Thank You Message'
  },
  description: {
    id: `${scope}.description`,
    defaultMessage:
      'Customise the greeting shown at the top of your post-tip links page (the “Thank you!” message above your links).'
  },
  save: {
    id: `${scope}.save`,
    defaultMessage: 'Save'
  },
  chooserTitle: {
    id: `${scope}.chooserTitle`,
    defaultMessage: 'Title'
  },
  chooserText: {
    id: `${scope}.chooserText`,
    defaultMessage: 'Message'
  },
  chooserTitlePlaceholder: {
    id: `${scope}.chooserTitlePlaceholder`,
    defaultMessage: 'Thank you!'
  },
  chooserTextPlaceholder: {
    id: `${scope}.chooserTextPlaceholder`,
    defaultMessage:
      'We hope you enjoyed your experience. We would be delighted if you visited one of the links below.'
  }
});
